import {
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { CurrencySource } from "../../../../../../../../../../../api/types/fieldConfigurationTypes";
import type { CurrencyDimensionMeta } from "../../../../../../../../../../../api/types/svTypes";
import { currencies } from "../currencyCodes";

interface Props {
  referenceDimensionName: string | undefined;
  currencySource: CurrencySource;
  currencyCode?: string;
  currencyDimensions: CurrencyDimensionMeta[];
  onReferenceDimensionNameChange: (referenceDimensionName: string) => void;
  onCurrencySourceChange: (currencySource: CurrencySource) => void;
  onCurrencyCodeChange: (currencySymbol: string) => void;
}
const CurrencySourceSelector = ({
  referenceDimensionName,
  currencySource,
  currencyCode,
  currencyDimensions,
  onReferenceDimensionNameChange,
  onCurrencySourceChange,
  onCurrencyCodeChange,
}: Props) => {
  return (
    <Stack spacing={1.5} sx={{ mb: 1 }}>
      <RadioGroup
        row
        value={currencySource}
        onChange={(evt) => onCurrencySourceChange(evt.target.value as CurrencySource)}
        sx={{ pl: 0.675 }}
      >
        <FormControlLabel value={CurrencySource.Static} control={<Radio />} label="Static Currency" />
        <FormControlLabel
          value={CurrencySource.Field}
          control={<Radio />}
          label="From Field"
          disabled={currencyDimensions.length === 0}
        />
      </RadioGroup>
      {currencySource === CurrencySource.Field && (
        <FormControl>
          <InputLabel id="select-label-field">Field</InputLabel>
          <Select
            labelId="select-label-field"
            label="Field"
            value={referenceDimensionName || currencyDimensions[0]?.name}
            onChange={(evt) => onReferenceDimensionNameChange(evt.target.value)}
          >
            {currencyDimensions.map((d) => (
              <MenuItem key={d.name} value={d.name}>
                {d.caption}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {currencySource === CurrencySource.Static && (
        <FormControl>
          <InputLabel id="select-label-currency">Currency</InputLabel>
          <Select
            labelId="select-label-currency"
            label="Currency"
            value={currencyCode}
            onChange={(evt) => onCurrencyCodeChange(evt.target.value)}
            MenuProps={{
              sx: {
                maxHeight: "350px",
              },
            }}
            renderValue={(value) => (
              <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between", flexWrap: "nowrap" }}>
                <Typography variant="body2">{value}</Typography>
                <Typography variant="body2" color="textSecondary">
                  {currencies.find((c) => c.code === value)?.description}
                </Typography>
              </Stack>
            )}
          >
            {currencies.map((c) => (
              <MenuItem
                key={c.code}
                value={c.code}
                sx={{ display: "flex", justifyContent: "space-between", flexWrap: "nowrap" }}
              >
                <Typography variant="body2">{c.code}</Typography>
                <Typography variant="body2" color="textSecondary">
                  {c.description}
                </Typography>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </Stack>
  );
};

export default CurrencySourceSelector;
